
export const convertDecimalToHoursMinutes = (decimalHours) => {
    const hours = Math.floor(decimalHours);
    const minutes = Math.round((decimalHours - hours) * 60); 

    return `${hours}h ${minutes}m`;
}

